import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";

export type CorrugatedSheetsCalculationConfig = {
    sheets: Array<OndulineProduct>;
    fixtures: Array<OndulineProduct>;
    accessories: Array<OndulineProductAccessory>;
    slopes: Array<SlopeConfig>;
};

export const ProductLine = {
    OndulineOndalux: "OndulineOndalux",
    OndulineEasyline: "OndulineEasyline",
    OnduLineEasyfix: "OnduLineEasyfix",
    Onduvilla: "Onduvilla"
} as const;
export type ProductLineType = (typeof ProductLine)[keyof typeof ProductLine];

export enum OndulineColor {
    Black = "0",
    Red = "1",
    Green = "2",
    Brown = "3"
}

export enum Sides {
    SingleSided = "single",
    DoubleSided = "double"
}

export type SlopeConfig = {
    below?: number;
    above?: number;
    division: number;
    fixtures: number;
    warning?: boolean;
};

export type OndulineProduct = {
    color: OndulineColor;
    sku: string;
    itemsPerPackage?: number;
};

export type FormulaResult = number;

export type OndulineProductAccessory = Omit<OndulineProduct, "color"> & {
    amountFormula: (length: number, width: number) => FormulaResult;
    requiredFixtures: number;
    twoSideMultiplier: number;
    condition?: (
        activeAcc: Array<OndulineProductTileModel>,
        isSingleSided: boolean
    ) => boolean;
    dependsOn?: string;
    color?: OndulineColor;
};

export type OndulineProductTileModel = Product<ProductFieldSet.ProductTile> & {
    amount: number;
    requiredFixtures: number;
    twoSideMultiplier: number;
    itemsPerPackage: number;
    dependsOn: string;
};

export type CorrugatedSheetShoppingList = {
    surface: number;
    slope: number;
    productLine?: ProductLineType;
    hasSlopeWarning: boolean;
    fixture?: OndulineProductTileModel;
    sheet?: OndulineProductTileModel;
    accessories: Array<OndulineProductTileModel>;
    color?: OndulineColor;
};
